// extracted by mini-css-extract-plugin
export var fileExt = "_v4-8";
export var fileIcon = "_v4-6";
export var fileLink = "_v4-5";
export var fileName = "_v4-7";
export var image = "_v4-1";
export var imageError = "_v4-3";
export var imageErrorIcon = "_v4-4";
export var imageLink = "_v4-0";
export var imageLoaded = "_v4-2";